import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";
import { PropsTableHead } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import {
  AbstractFilters,
  AbstractRow,
} from "src/components/ReactiveTable/RtTypes";

import { HeaderCell } from "../cell/HeaderCell";
import * as stylesCommon from "./common.module.less";
import { getCellClassName } from "./getCellClassName";
import { getCellStyle } from "./getCellStyle";
import * as styles from "./TableHead.module.less";

/**
 * Компонент шапки таблицы
 */
export const TableHead = observer(
  <TRow extends AbstractRow, TFilters extends AbstractFilters>(
    props: PropsTableHead<TRow, TFilters>,
  ) => {
    const {
      store,
      columnFilters,
      resizableColumns,
      components,
      fixedColumnsMap,
    } = props;
    const { SelectionHeader } = components;
    const columns = store.visibleColumns;

    return (
      <div className={classNames([stylesCommon.commonRow, styles.tableHead])}>
        {/* Колонка для selection (если включен) */}
        {store.selectionType && <SelectionHeader store={store} />}

        {/* Ячейки заголовков */}
        {columns.map((column) => {
          const fixedInfo = fixedColumnsMap?.get(column.key);
          return (
            <HeaderCell
              key={column.key}
              column={column}
              store={store}
              columnFilters={columnFilters}
              resizable={
                resizableColumns && column.capabilities?.resizable !== false
              }
              className={getCellClassName(fixedInfo)}
              style={getCellStyle(column, store, fixedInfo)}
            />
          );
        })}
      </div>
    );
  },
);
